import { ISearchQueryObject } from './Search';
import * as reduxAction from 'redux-actions';


// Constants
export const SEARCH = "SEARCH.DO_SEARCH"



// Actions

export function doSearchAction(searchQuery: ISearchQueryObject){
    return reduxAction.createAction(SEARCH)(searchQuery)
}


// WEBPACK FOOTER //
// ./src/Entities/Search/Search.Actions.ts